import { Component } from "react";
import { formatUrlSeo } from "../../util/seo-url";
import EllipsisText from 'react-ellipsis-text';
import React = require("react");
import Spinner from '../share/Spinners/Spinners'
import { loadImage } from "../../util/image";
import TinTucService from "../../services/tinTuc";
import { DANH_MUC } from "../../const/danh-muc";
import { TinTuc } from "../../models";
import Link from "next/link";
import * as _ from "lodash";
var Chance = require('chance');
const chance = new Chance();

import Image from "../share/Image";
import { NEWS } from "../../const/seo-url";
import CarouselSlide from "../share/CarouselSlide";
import SpinnersHDVH from "../share/Spinners/SpinnersImageText";

export default class extends Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      tin_tuc: [],
      loading: false,
      firstDuAn: null,
      slides: [],
      megastory_big: null,
      megastory_small: [],

    }
  }

  static async getInitialProps() {

    return
  }


  componentDidMount() {
    TinTucService.getList(
      DANH_MUC.MEGESTORY,
      1,
      3
    ).then(value => {
      if (value.danhSachTinTuc) {
        if (value.danhSachTinTuc.length > 0) {
          this.setState({
            tin_tuc: value.danhSachTinTuc,
            megastory_big: value.danhSachTinTuc.splice(0, 1),
            megastory_small: value.danhSachTinTuc
          });
        }
        this.setState({
          loading: true
        });

      }
    });
  }
  buildItemBig() {
    if (this.state.megastory_big.length > 0) {
      var tinBig = this.state.megastory_big[0]
      return (
        <div>
          {tinBig == null ? (
            <div>Loading...</div>
          ) : (
            <div>
              <div className="image-news-home">
                <a
                  href={`/${NEWS.MEGASTORY}/${tinBig.url_seo_tin}`}
                  className="link-img"
                >
                  <div className="text-bold pb-2">
                    <a href={`/${NEWS.MEGASTORY}`} className="btn btn-primary" style={{ backgroundColor: "#FF0000", borderColor: "#FF0000" }}>MEGASTORY</a>
                    <b className="btn text-bold" style={{ color: "#0071BB", whiteSpace: "initial", display: "initial", fontSize: "15px" }}>{tinBig.tieuDe}</b>
                  </div>
                  <img
                    className="img-responsive"
                    alt={tinBig.tieuDe}
                    src={loadImage(tinBig.hinhThumbnail)}
                  />
                </a>
              </div>
              <p className="des_news">{tinBig.moTa}</p>
            </div>
          )}
        </div>
      );
    } else {
      <div>Loading...</div>;
    }
  }
  // buildItemBig() {
  //   if (this.state.megastory_big.length > 0) {
  //     var tinBig = this.state.megastory_big[0]
  //     return (
  //       <div className="col-sm-8">
  //         <a href={`/${NEWS.MEGASTORY}/${tinBig.url_seo_tin}`}>
  //           <div className="text-bold pb-2">
  //             <a href={`/${NEWS.MEGASTORY}`} className="btn btn-danger">MEGASTORY</a>
  //             <b style={{ fontSize: "20px" }}>{tinBig.tieuDe}</b>
  //           </div>
  //           <div className="img  pb-2">
  //             <Image src={tinBig.hinhThumbnail} alt="" className="img-responsive img-fluid" classPlaceHolder="lazy-image-list" />
  //           </div>
  //           <div className="desc">
  //             <div className="trimtext" style={{ fontSize: "15px", lineHeight: "1.6" }}>
  //               <div>{tinBig.moTa}
  //               </div>
  //             </div>
  //           </div>
  //         </a>
  //       </div>
  //     )
  //   } else {
  //     return <div></div>
  //   }
  // }
  buildItemSmall() {
    if (this.state.megastory_small.length > 0) {
      return (
        <div className="right-tuyen-sinh">
          <div className="content-right-tuyen-sinh back-gray">
            {this.state.megastory_small.map((tinTuc) => (
              <div>
                <span>
                  <a
                    href={`/${NEWS.MEGASTORY}/${tinTuc.url_seo_tin}`}
                    className=" link-img title "
                  >
                    <Image
                      src={loadImage(tinTuc.hinhThumbnail)}
                      alt=""
                      className="img-responsive"
                      classPlaceHolder="lazy-image-list"
                    />
                  </a>
                  <a
                    href={`/${NEWS.MEGASTORY}/${tinTuc.url_seo_tin}`}
                    className="title text-bold wow slideInUp animated animated"
                    style={{
                      visibility: "visible",
                      animationName: "slideInUp"
                    }}

                  >
                    {tinTuc.tieuDe}
                  </a>
                </span>

              </div>
            ))}
             {this.buildItemViewAll()}
          </div>
        </div>
      );
    } else {
      return <div></div>;
    }
  }
  // buildItemSmall() {
  //   if (this.state.megastory_small.length > 0) {
  //     return <div className="col-sm-4 back-gray pt-2">
  //       {this.state.megastory_small.map((tinTuc) => (
  //         <a href={`/${NEWS.MEGASTORY}/${tinTuc.url_seo_tin}`}>
  //           <div className="img  pb-2">
  //             <Image src={tinTuc.hinhThumbnail} alt="" className="img-responsive img-fluid" classPlaceHolder="lazy-image-list" />
  //           </div>
  //           <div className="text-bold pb-2">
  //             <b style={{ fontSize: "13px" }}>{tinTuc.tieuDe}</b>
  //           </div>
  //         </a>
  //       ))}
  //     </div>
  //   } else {
  //     return <div></div>
  //   }
  // }
  buildItemViewAll() {

    return <div className="w-full text-right" style={{ padding: 0 }}>
          <Link href="/megastory" legacyBehavior>
            <a className="more text-orange">
              <b>See all &gt;&gt;</b>
            </a>
          </Link>
        </div>
     
  }

  buildTinTuc() {
    if (this.state.tin_tuc.length > 0) {
      return (
          <div className="content-block height-block">
            <div className="row" style={{ margin: "0" }}>
              <div className="col-md-8 news-block-left">
                {this.buildItemBig()}
              </div>
              <div className="col-md-4 news-block-right">
                {this.buildItemSmall()}
               
              </div>
            </div>
            
           
          </div>
        // <div className="row" style={{ margin: "0 -8px" }}>
        //   {this.buildItemBig()}
        //   {this.buildItemSmall()}
        //   {this.buildItemViewAll()}
        // </div>
      )
    }
    else {
      <div>No data</div>
    }
  }

  render() {
    return (
      <div className="block back-hoatdongvuihoc">
        {/* <div className="container"> */}

        {
          this.state.loading ? (
            <div>
              {this.buildTinTuc()}

            </div>
          ) : <SpinnersHDVH type={'placeholde'} loading={true} />
        }
        {/* </div> */}
      </div>
    );

  }
}
